import { render, staticRenderFns } from "./new-company.vue?vue&type=template&id=cf811398&scoped=true&"
import script from "./new-company.vue?vue&type=script&lang=js&"
export * from "./new-company.vue?vue&type=script&lang=js&"
import style0 from "./new-company.vue?vue&type=style&index=0&id=cf811398&scoped=true&lang=scss&"
import style1 from "./new-company.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf811398",
  null
  
)

export default component.exports